'use es6';

import { SFDC_GET_INTEGRATION_STATUS } from 'DesignData/actions/ActionTypes';
export default function salesforceIntegrationStatus(state = null, action) {
  switch (action.type) {
    case SFDC_GET_INTEGRATION_STATUS:
      {
        const {
          status
        } = action;
        if (status) return status.integrationStatus;
        return state;
      }

    default:
      return state;
  }
}